<template>
    <ManageSidebarContainer>
        <SidebarHeader>
            <HeaderIcon>
                <ViewDashboard :size="30" />
            </HeaderIcon>
            <HeaderTitle>관리 목록</HeaderTitle>
        </SidebarHeader>

        <MenuContainer>
            <MenuCategory @click="goToPage('company')"> <MenuIcon><Domain :size="30" /></MenuIcon> 거래처 관리</MenuCategory>
            <MenuCategory @click="goToPage('client')"> <MenuIcon><AccountGroup :size="30" /></MenuIcon> 고객 관리</MenuCategory>
            <MenuCategory @click="goToPage('migration')"> <MenuIcon><MicrosoftExcel :size="30" /></MenuIcon> 이관 관리</MenuCategory>
            <MenuCategory @click="goToPage('data')"> <MenuIcon><Finance :size="30" /></MenuIcon> 통계 관리</MenuCategory>
            <MenuCategory @click="goToPage('system')"> <MenuIcon><CogOutline :size="30" /></MenuIcon> 시스템 관리</MenuCategory>
        </MenuContainer>
    </ManageSidebarContainer>
</template>

<script>
import * as ManageSidebarCss from '@/assets/styles/manage/ManageSidebarCss';

import ViewDashboard from 'vue-material-design-icons/ViewDashboard.vue';
import Domain from 'vue-material-design-icons/Domain.vue';
import AccountGroup from 'vue-material-design-icons/AccountGroup.vue';
import FileDocumentOutline from 'vue-material-design-icons/FileDocumentOutline.vue';
import MicrosoftExcel from 'vue-material-design-icons/MicrosoftExcel.vue';
import CogOutline from 'vue-material-design-icons/CogOutline.vue';
import Finance from 'vue-material-design-icons/Finance.vue';

export default {
    name: 'ManageSidebar',

    components: {
        ...ManageSidebarCss,
        ViewDashboard,
        Domain,
        AccountGroup,
        FileDocumentOutline,
        CogOutline,
        Finance,
        MicrosoftExcel
    },

    data() {
        return {
            openSubmenu: null,
            currentPage: null
        }
    },

    methods: {
        goToPage(page) {
            this.currentPage = page;
            this.$router.push(`/manage/${page}`);
        },
    }
}
</script>